import { render, staticRenderFns } from "./TechItem.vue?vue&type=template&id=1fab1f04&scoped=true&"
import script from "./TechItem.vue?vue&type=script&lang=js&"
export * from "./TechItem.vue?vue&type=script&lang=js&"
import style0 from "./TechItem.vue?vue&type=style&index=0&id=1fab1f04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fab1f04",
  null
  
)

export default component.exports